module.exports = __webpack_public_path__ + "img/banner-03e.8a73b1da.png";